<div ng-controller="systemToolsController as ctrl">
    <c-simple-list configuration="ctrl.listConfig" items="ctrl.tools"></c-simple-list>

    <ui-view>
        <div class="no-list-renderer"  ng-if="!ctrl.showBlank">
            <ul class="list-ctx">
                <li>
                    <div class="list-item end-of-list">
                        <div>
                            <h3>
                                {{ctrl.noItemsInList}}
                            </h3>
                        </div>
                        <div class="end-image" ng-bind-html="ctrl.endImage">
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </ui-view>
</div>